export default __webpack_public_path__ + "a125739500a06dba4949b21db6f9995a.svg";